import styled from 'styled-components';
import { ImageWrapperStyle } from '../../PortraitItem/PortraitItem.style';

export const FormatsSectionPosterWrapperStyle = styled.div`
  width: 100%;

  ${ImageWrapperStyle} {
    border-radius: unset;
  }
`;
